import { useLocation, useNavigate, Outlet } from "react-router-dom"
import { sidebarActionOptions, sidebarOptions } from "constants/sidebarRoutes"
import styled from "styled-components"
import BeatLayout from "../../Beat/BeatSidebar"
import { useQueryState } from "context/queryState"
import { USER_PERSONAL_INFO } from "reducers/user/actions-types"
import { AppState, useAppDispatch, useAppSelector } from "reducers/store"
import { getUserPersonalInfo } from "api/user"
import { useCallback } from "react"
import { signOut } from "reducers/user/user-actions"
import useResetQuery from "hooks/useResetQuery"

const Container = styled.div`
  background-color: ${(props) => props.theme.palette.gray_ice};
`

const SidebarRoutes = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { resetAllQueries } = useResetQuery()

  useQueryState([USER_PERSONAL_INFO], async () => getUserPersonalInfo(), USER_PERSONAL_INFO, {
    refetchOnMount: "always"
  })

  const { name } = useAppSelector((x: AppState) => x.user.userPersonalInfo.data)

  const logout = useCallback(() => {
    resetAllQueries()
    dispatch(signOut(navigate))
  }, [])

  return (
    <Container>
      <BeatLayout
        options={sidebarOptions}
        actionOptions={sidebarActionOptions(name, logout)}
        location={location}
        navigate={navigate}
        className="background-gradient"
      >
        {/* This enables the layout route concept from react-router-dom to work */}
        <Outlet />
      </BeatLayout>
    </Container>
  )
}

export default SidebarRoutes
